<div class="ui-dialog">
    <h3 class="ui-dialog-title ui-title" mat-dialog-title>Detalle</h3>

    <div class="ui-dialog-content" mat-dialog-content>
        <span>{{data.detail}}</span>
    </div>

    <div class="ui-dialog-actions" mat-dialog-actions>
        <button mat-button (click)="onClose()" color="primary">Cerrar</button>
    </div>
</div>